import React, { Fragment, ReactElement } from 'react';

import { Container } from '@constellation/core';
import PageHeading from 'components/pageHeading/PageHeading';

import { ThreeStepsToRegisterDelegateAccessComponentProps } from '../../pages/threeStepsToRegisterDelegateAccess/ThreeStepsToRegisterDelegateAccess.config';
import RegistrationSteps from '../registrationSteps/RegistrationSteps';

function ThreeStepsToRegister({ data, externalLink }): ReactElement {
  return (
    <Container padding="none">
      {data &&
        data.map(
          ({
            serviceName,
            header,
            description,
            registrationSteps,
            nextBtn,
            nextBtnHref,
            previousLink,
            previousHref,
          }: ThreeStepsToRegisterDelegateAccessComponentProps) => (
            <Fragment key="three-steps-to-register-container">
              <PageHeading serviceName={serviceName} header={header} />
              <RegistrationSteps
                description={description}
                data={registrationSteps}
                nextBtn={nextBtn}
                nextBtnHref={nextBtnHref}
                previousLink={previousLink}
                previousHref={previousHref}
                externalLink={externalLink}
              />
            </Fragment>
          ),
        )}
    </Container>
  );
}

export default ThreeStepsToRegister;
